import { render } from "./UserUpdateProfile.vue?vue&type=template&id=10c55ab5"
import script from "./UserUpdateProfile.vue?vue&type=script&lang=js"
export * from "./UserUpdateProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__